import './Landing.css';
import Carousel from './UI/Carousel';
import Navbar from './UI/Navbar';
import { Button } from '@mui/material';


const Landing = () => {
  return (
    <body>
      <div className='landing-container'>
        <Navbar />
        <div className="landing-main-container">
          <Button
            variant='contained'
            href='/home'
            sx={{ display: { sx: 'flex', md: 'none' }, mr: 1, bgcolor: '#9924f1', width: '206px', ':hover': { bgcolor: '#8119d1' } }}
          >
            Checkout Roadmaps
          </Button>
          <div className="landing-intro-container">
            <div className="landing-heading">
              <h1>DISCOVER</h1>
              <h1>YOUR</h1>
              <h1>CHOSEN</h1>
              <h1>NICHE</h1>
            </div>
            <div className="landing-para">
              <p>An ideal destination to uncover the path for the domain you adore!!!!</p>
            </div>
          </div>
          <Carousel></Carousel>
        </div>
      </div>
    </body>
  );
}

export default Landing;